import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { BrandService } from 'shared/brand/brand.service';
import { SearchModel } from 'shared/search/search.model';

import { SuggestedAttributesService } from './suggested-attributes.service';
import { columns } from './columns';

@Component({
  moduleId: module.id,
  selector: 'suggested-attributes',
  templateUrl: 'suggested-attributes.component.html',
  styleUrls: ['suggested-attributes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestedAttributesComponent extends SearchWidgetComponent implements OnInit {
  searchModel = new SearchModel();
  loading: boolean = false;
  items: Array<any> = [];
  exclude: Array<any> = [];
  itemId: string;
  partTerminologyId: string;

  @Input() hasPartType: boolean;

  @Output() addAttributes  = new EventEmitter();

  constructor(
    public searchService: SuggestedAttributesService,
    protected brandService: BrandService,
    protected ref: ChangeDetectorRef,
  ) {
    super(
      brandService,
      searchService,
    );
    this.initSearchModel();
  }

  get isEmpty(): boolean {
    return this.totalRecords === 0;
  }

  ngOnInit() {
    this.initSubscriptions();
  }

  // public
  public setData(itemId: string, partTerminologyId: string) {
    this.itemId = itemId;
    this.partTerminologyId = partTerminologyId;
    this.runSearch(this.searchModel);
  }

  public removeFilters(attributesIds: any[]) {
    this.exclude = _.difference(this.exclude, attributesIds);
    this.runSearch(this.searchModel);
  }

  public clearFilters() {
    this.exclude = [];
    this.runSearch(this.searchModel);
  }

  public resetData(): void {
    this.searchModel = new SearchModel();
    this.items = [];
    this.deselectAll();
    this.ref.markForCheck();
  }

  public excludeItems(items: Array<any>) {
    _.forEach(items, (item: any) => {
      this.exclude.push(item.id);
    });
  }

  public excludeSelectedItems(): void {
    this.excludeItems(this.searchService.selectedItems);
  }

  runSearch(searchModel: SearchModel) {
    // this.startLoading();
    if (!this.itemId || !this.partTerminologyId) {
      return;
    }
    this.searchService.runSearch(
      this.brandService.getBrand(),
      searchModel,
      this.itemId,
      this.partTerminologyId,
      this.exclude,
    )
    .subscribe(data => {
      this.items = data.data;
      _.forEach(this.items, item => {
        item.is_padb = 'Y';
      });
      this.ref.markForCheck();
      // this.stopLoading();
    });
  }

  // private
  private initSearchModel() {
    this.searchModel.itemsPerPage = 25;
    this.searchResultsColumns = columns;
  }

  private deselectAll() {
    this.searchService.searchModel.selectAll = 'on-page';
    this.searchService.selectAll(false);
  }
}
